import { APP_URL } from "utils";
import { httpClient } from "utils/axios";

export interface ThesisParams {
  ItemTypeId: number;
  Branches?: string[];
  DefencDate?: string;
  Degree?: string;
  Supervisor?: string;
  Major?: string;
  Consultor?: string;
  Abstract?: string;
  MainDescriptor?: string;
  SubDescriptor?: string;
  AuthorStatement?: string;
  ItemId?: number;
  PageSize?: number;
  PageNumber?: number;
}

export interface PayamLibThesesNormalized {
  Items: PayamLibThesisNormalized[];
}

export interface PayamLibThesisNormalized {
  itemId: number;
  itemTypeId: number,
  title: string;
  authorStatement: string;
  branch: string;
  major: string;
  degree: string;
  defencDate: string;
  abstract: string;
  supervisor: string[];
  consultor: string[];
  mainDescriptor: string[];
}

export class PayamLibService {
  getTheses = async (params: ThesisParams) => {
    try {
      const queryParams = new URLSearchParams();

      for (const [key, value] of Object.entries(params)) {
        if (key === "Branches" && Array.isArray(value)) {
          value.forEach((branch) => {
            if (branch && branch.trim() !== "") {
              queryParams.append("SelectedBranches", branch.trim());
            }
          });
        } else if (value !== undefined && value !== null && value !== "") {
          queryParams.append(key, value.toString());
        }
      }

      const queryString = queryParams.toString();
      const url = `${APP_URL}/api/payamLib/theses?${queryString}`;

      // console.log("🔗 Calling API:", url);

      const response = await httpClient.get(url);

      // console.log("📦 Full API Response:", response.data);

      // برگردوندن کل response
      return response.data;
    } catch (error: any) {
      console.error("❌ Error in getThesis:", error);
      throw error;
    }
  };
}
export const payamLibService = new PayamLibService();
